import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 18679 18297"
    {...props}
  >
    <defs>
      <style>
        {".str0{stroke:#fefefe;stroke-width:207}.fil0{fill:#231f20}"}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1974613564176">
        <path
          d="M9601 8696c-611 0-1106 495-1106 1105s495 1105 1106 1105c610 0 1105-495 1105-1105s-495-1105-1105-1105zM8853 121c-31-12-63-18-96-18-224 0-339 256-204 434 2417 3191 456 4600 529 7931 161-63 335-99 519-99 159 0 312 28 456 76 54-361 264-1000 1026-1747 1178-1157 3060-4599-2230-6577zM163 7521c-20 25-36 55-46 85-69 214 138 402 350 328 3781-1312 4515 988 7705 1948-10-172 10-349 67-524 49-151 122-289 213-410-327-163-869-561-1345-1516-736-1477-3428-4331-6944 89zM4515 18072c18 27 41 51 68 70 181 132 424-7 419-231-79-4002 2335-3989 4234-6726-167-44-329-118-477-225-130-95-238-207-325-330-256 260-802 653-1857 810-1632 244-5179 1922-2062 6632zM15895 17193c31-9 61-23 87-42 182-132 125-406-89-471-3831-1160-3073-3453-5089-6105-94 145-214 277-362 385-129 94-269 161-414 207 169 323 374 964 197 2016-273 1628 228 5519 5670 4010zM18576 6099c1-32-3-66-13-97-70-213-348-243-476-59-2288 3284-4233 1855-7379 2953 110 133 198 288 254 462 49 153 71 307 69 458 360-60 1033-57 1979 436 1464 763 5319 1489 5566-4153z"
          className="fill stroke1"
          style={{
            strokeWidth: 207,
          }}
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
